// extracted by mini-css-extract-plugin
export default {"container":"RigthClickMenu_container__XJc4v","wrapperMenu":"RigthClickMenu_wrapperMenu__6coHz"};